export default __webpack_public_path__ + "static/media/motorcycling.3a534138.jpg";